import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "./api";

const B2BAuthCtx = createContext(null);

export function B2BAuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  const checkSession = useCallback(async () => {
    const token = localStorage.getItem("bnx_b2b_token");
    if (!token) { setUser(null); return; }
    try {
      const { data } = await api.get("/b2b-auth/me", { headers: { Authorization: `Bearer ${token}` } });
      setUser(data);
    } catch {
      localStorage.removeItem("bnx_b2b_token");
      setUser(null);
    }
  }, []);

  useEffect(() => { checkSession(); }, [checkSession]);

  const login = useCallback(async (email, password, remember_me) => {
    try {
      const { data } = await api.post("/b2b-auth/login", { email, password, remember_me });
      localStorage.setItem("bnx_b2b_token", data.token);
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/b2b-auth/logout", null, { headers: { Authorization: `Bearer ${localStorage.getItem("bnx_b2b_token")}` } }); } catch {}
    localStorage.removeItem("bnx_b2b_token");
    setUser(null);
  }, []);

  const refresh = checkSession;

  return <B2BAuthCtx.Provider value={{ user, login, logout, refresh }}>{children}</B2BAuthCtx.Provider>;
}

export function useB2BAuth() {
  const ctx = useContext(B2BAuthCtx);
  if (!ctx) throw new Error("useB2BAuth must be used within B2BAuthProvider");
  return ctx;
}

// axios helper: adds B2B token to request if present in localStorage (for B2B routes only)
export function b2bApi() {
  const token = localStorage.getItem("bnx_b2b_token");
  return {
    get: (url, opts = {}) => api.get(url, { ...opts, headers: { ...(opts.headers || {}), Authorization: `Bearer ${token}` } }),
    post: (url, body, opts = {}) => api.post(url, body, { ...opts, headers: { ...(opts.headers || {}), Authorization: `Bearer ${token}` } }),
    put: (url, body, opts = {}) => api.put(url, body, { ...opts, headers: { ...(opts.headers || {}), Authorization: `Bearer ${token}` } }),
    delete: (url, opts = {}) => api.delete(url, { ...opts, headers: { ...(opts.headers || {}), Authorization: `Bearer ${token}` } }),
  };
}
